import type { Action } from 'redux';

import normaliseError, { type NormaliseErrorInput } from '/shared/functions/normaliseError';
import type { NormalisedError, emissionDropdown } from '/index';

export interface EmissionTypeOption extends emissionDropdown {}

export interface RefrigerantTypeOption extends EmissionTypeOption {
  group: string;
  units: string[];
}

export interface EmissionTypesData {
  commuterFactors?: EmissionTypeOption[];
  deicing?: EmissionTypeOption[];
  fuel?: EmissionTypeOption[];
  refrigerants?: RefrigerantTypeOption[];
  waste?: EmissionTypeOption[];
}

export interface EmissionTypesState {
  data: EmissionTypesData | null;
  fetching: boolean;
  fetched: boolean;
  error?: NormalisedError | null;
}

interface GetEmissionTypesStartedAction extends Action {
  type: 'GET_EMISSION_TYPES_STARTED';
}

interface GetEmissionTypesFulfilledAction extends Action {
  type: 'GET_EMISSION_TYPES_FULFILLED';
  emissionTypes: EmissionTypesData;
}

interface GetEmissionTypesRejectedAction extends Action {
  type: 'GET_EMISSION_TYPES_REJECTED';
  error: NormaliseErrorInput;
}

interface SetApplicationActiveFulfilledAction extends Action {
  type: 'SET_APPLICATION_ACTIVE_FULFILLED';
}

type EmissionTypesAction =
  | GetEmissionTypesStartedAction
  | GetEmissionTypesFulfilledAction
  | GetEmissionTypesRejectedAction
  | SetApplicationActiveFulfilledAction;

const defaultState: EmissionTypesState = {
  data: null,
  fetching: false,
  fetched: false,
};

function reducer(state: EmissionTypesState = defaultState, action: EmissionTypesAction): EmissionTypesState {
  switch (action.type) {
    case 'GET_EMISSION_TYPES_STARTED': {
      return {
        ...state,
        fetching: true,
        error: null,
      };
    }
    case 'GET_EMISSION_TYPES_FULFILLED': {
      const { emissionTypes } = action;
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: emissionTypes,
        error: null,
      };
    }
    case 'GET_EMISSION_TYPES_REJECTED': {
      const { error } = action;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: normaliseError(error),
      };
    }
    case 'SET_APPLICATION_ACTIVE_FULFILLED': {
      return {
        ...defaultState,
      };
    }
    default:
      return state;
  }
}

export default reducer;
